export const globalAppAndLanguageDefaultState = {
  app: "seekho",
  language: "hi",
};

export const NAV_SCOPE = { app: "app", global: "global" };

export const GLOBAL_APP_HEADERS = { app: "App-Name", language: "App-Language" };

export const GLOBAL_APP_DETAIL_ROUTES = [
  {
    pattern: /^\/dashboard\/ad-request\/\d+/,
    listPath: "/dashboard/ad-request",
  },
];

export const APP_SWITCH_DURATION = 1700;

export const APP_SWITCH_FAN_STEP_X = 110;

export const APP_SWITCH_FAN_STEP_ROTATE = 12;

const APP_LOGOS = {
  seekho: "/static/images/globalApps/seekho.webp",
  seekho_junior: "/static/images/globalApps/seekho-jr.webp",
  seekho_english: "/static/images/globalApps/seekho-english.webp",
  seekho_health: "/static/images/globalApps/seekho-health.webp",
};

/** Logo of an app, Seekho's for an unknown one. */
export const handleGetAppLogo = ({ app }) => APP_LOGOS[app] || APP_LOGOS.seekho;
